export const MARKETPLACE_CHAT_TOPIC_PURPOSE = 'marketplace-chat-notification';
export const COMPLAINT_CHAT_TOPIC_PURPOSE = 'complaint-chat-notification';
export const SELF_MEDICATION_CHAT_TOPIC_PURPOSE =
  'self-medication-chat-notification';
